import React, { useState, useEffect } from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const avatars = [
  {
    src: "https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?auto=format&fit=crop&w=64&h=64",
    fallback: "U1"
  },
  {
    src: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=64&h=64",
    fallback: "U2"
  },
  {
    src: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=64&h=64",
    fallback: "U3"
  },
  {
    src: "https://images.unsplash.com/photo-1580518337843-f959e992563b?auto=format&fit=crop&w=64&h=64",
    fallback: "U4"
  }
];

const FoundersBanner = () => {
  const [count, setCount] = useState(322);
  const targetNumber = 543;
  const duration = 2000; // 2 seconds

  useEffect(() => {
    let startTimestamp: number | null = null;
    const startNumber = 322;

    const animate = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      const percentage = Math.min(progress / duration, 1);
      
      const currentCount = Math.floor(
        startNumber + (targetNumber - startNumber) * percentage
      );
      
      setCount(currentCount);

      if (percentage < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  return (
    <div className="flex items-center justify-center gap-2 mb-6 animate-fade-in">
      <div className="flex -space-x-2">
        {avatars.map((avatar, index) => (
          <Avatar
            key={index}
            className="border-2 border-white w-6 h-6 md:w-8 md:h-8 hover:scale-110 transition-transform duration-200"
          >
            <AvatarImage src={avatar.src} alt="User avatar" />
            <AvatarFallback>{avatar.fallback}</AvatarFallback>
          </Avatar>
        ))}
      </div>
      <span className="text-drcash-cadet-gray md:text-sm text-xs">
        +{count} donos na última semana
      </span>
    </div>
  );
};

export default FoundersBanner;
